//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Form from 'components/Form'
import { scroll } from 'quasar'
const { getScrollTarget, setScrollPosition } = scroll
export default {
  name: 'PageIndex',
  components: {
    Form
  },
  data () {
    return {
      bottomCTA: true,
      mobileForm: null,
      displayMentions: false
    }
  },
  mounted () {
    this.mobileForm = document.getElementById('MobileForm')
    this.desktopForm = document.getElementById('DesktopForm')
  },
  methods: {
    goToForm () {
      if (this.$q.platform.is.mobile) {
        this.scrollTo(this.mobileForm)
      } else {
        this.scrollTo(this.desktopForm)
      }
    },
    scrollTo (el) {
      const target = getScrollTarget(el)
      const offset = el.offsetTop - 50
      const duration = 400
      setScrollPosition(target, offset, duration)
    },
    scrollHandler (details) {
      if (details.position >= this.mobileForm.offsetTop - 50) {
        this.bottomCTA = false
      } else {
        this.bottomCTA = true
      }
    }
  }
}
